const EventEmitter = require("events");

class Stream extends EventEmitter{}

const stream = new Stream();
export default stream;